import React, { useState, useEffect, useContext } from 'react';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Grid from '@mui/material/Grid';
import { Stack, TextField, Autocomplete } from '@mui/material';
import { AccordionSummary, AccordionDetails, Accordion } from '../shared/components/accordion';
import { FormMode, Districts, ConstantValues } from '../utils/extensions/constantEx';
import { AddressFormInitalState } from '../utils/hooks/useNurseForm';
import { NurseFormContext } from '../utils/contexts/nurseFormContext';

const NurseAddress = (props) => {

    const { formOpenMode, isShowValidationMsgs, panelId } = props;
    const { nurseFormValue, selectedNurseJosn, SetNurseFormValue } = useContext(NurseFormContext);

    const [id, setId] = useState(0);
    const [addressText, setAddressText] = useState('');
    const [selectedDistrict, setSelectedDistrict] = useState(null);
    const [pinCode, setPinCode] = useState('');
    const [thaluk, setThaluk] = useState('');
    const [panchayat, setPanchayat] = useState('');
    const [wardNo, setWardNo] = useState(0);

    useEffect(() => {
        let addressModelTemp = null;
        let tempId = -1;

        if ((formOpenMode === FormMode.ViewMode || formOpenMode === FormMode.EditMode) && selectedNurseJosn && selectedNurseJosn.id > 0) {
            if (panelId === 'nurse-address1-panel-content' && selectedNurseJosn.address1) {
                addressModelTemp = { ...selectedNurseJosn.address1 };
                tempId = addressModelTemp.id;
            }
            else if (panelId === 'nurse-address2-panel-content' && selectedNurseJosn.address2) {
                addressModelTemp = { ...selectedNurseJosn.address2 };
                tempId = addressModelTemp.id;
            }
        }
        if (!addressModelTemp) {
            addressModelTemp = { ...AddressFormInitalState };
        }
        setId(tempId);
        setAddressText(addressModelTemp.address);
        setSelectedDistrict(addressModelTemp.district);
        setPinCode(addressModelTemp.pincode);
        setThaluk(addressModelTemp.thaluk);
        setPanchayat(addressModelTemp.panchayat);
        setWardNo(addressModelTemp.ward);
    }, [formOpenMode, selectedNurseJosn]);

    useEffect(() => {
        handleChange();
    }, [addressText, selectedDistrict, pinCode, thaluk, panchayat, wardNo]);

    const handleChange = () => {
        const tempNurse = { ...nurseFormValue };
        const tempAddress = { ...AddressFormInitalState };

        if (addressText.trim().length > 0 || pinCode.trim().length > 0 || thaluk.trim().length > 0
            || panchayat.trim().length > 0 || wardNo > 0 || (selectedDistrict && selectedDistrict.trim().length > 0)) {

            tempAddress.id = ConstantValues.DefaultContactAddressId === id ? 0 : id;
            tempAddress.address = addressText;
            tempAddress.district = selectedDistrict;
            tempAddress.pincode = pinCode;
            tempAddress.thaluk = thaluk;
            tempAddress.panchayat = panchayat;
            tempAddress.ward = wardNo;
        }

        if (panelId === 'nurse-address1-panel-content') {
            tempNurse.address1 = { ...tempAddress };
        } else if (panelId === 'nurse-address2-panel-content') {
            tempNurse.address2 = { ...tempAddress };
        }
        SetNurseFormValue(tempNurse);
    }

    return (
        <div>
            <Accordion defaultExpanded>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="nurse-address-panel-content"
                    id={panelId}
                >
                    <Typography component="span">{props.headerText}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Stack spacing={2}>
                        <TextField size="small" fullWidth
                            label="Address"
                            multiline
                            rows={4}
                            value={addressText}
                            onChange={(event) => {
                                setAddressText(event.target.value);
                            }}
                            slotProps={{
                                input: {
                                    readOnly: formOpenMode === FormMode.ViewMode
                                },
                            }}
                            error={isShowValidationMsgs && addressText.trim().length === 0 ? true : false}
                            helperText={isShowValidationMsgs && addressText.trim().length === 0 ? 'Enter address' : ''}
                        />

                        <Grid container spacing={1}>
                            <Grid size={10}>
                                <Autocomplete
                                    readOnly={formOpenMode === FormMode.ViewMode}
                                    id="combo-box-district"
                                    options={Districts}
                                    value={selectedDistrict}
                                    getOptionLabel={(option) => option}
                                    onChange={(event, newValue) => {
                                        setSelectedDistrict(newValue);
                                    }}
                                    renderInput={(params) =>
                                        <TextField {...params} label="District" size="small" fullWidth required={isShowValidationMsgs}
                                            error={isShowValidationMsgs && !selectedDistrict ? true : false}
                                            helperText={isShowValidationMsgs && !selectedDistrict ? 'Select district' : ''}
                                        />}
                                />
                            </Grid>
                            <Grid size={2}>
                                <TextField size="small" fullWidth label="PIN Code"
                                    value={pinCode}
                                    onChange={(event) => {
                                        setPinCode(event.target.value);
                                    }}
                                    slotProps={{
                                        input: {
                                            readOnly: formOpenMode === FormMode.ViewMode
                                        },
                                    }}
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={1}>
                            <Grid size={5}>
                                <TextField size="small" fullWidth
                                    label="Thaluk"
                                    value={thaluk}
                                    onChange={(event) => {
                                        setThaluk(event.target.value);
                                    }}
                                    slotProps={{
                                        input: {
                                            readOnly: formOpenMode === FormMode.ViewMode
                                        },
                                    }}
                                />
                            </Grid>
                            <Grid size={5}>
                                <TextField size="small" fullWidth
                                    label="Panchayat"
                                    value={panchayat}
                                    onChange={(event) => {
                                        setPanchayat(event.target.value);
                                    }}
                                    slotProps={{
                                        input: {
                                            readOnly: formOpenMode === FormMode.ViewMode
                                        },
                                    }}
                                />
                            </Grid>
                            <Grid size={2}>
                                <TextField size="small" fullWidth type="number"
                                    label="Ward No"
                                    value={wardNo}
                                    onChange={(event) => {
                                        setWardNo(event.target.value);
                                    }}
                                    slotProps={{
                                        input: {
                                            readOnly: formOpenMode === FormMode.ViewMode
                                        },
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Stack>

                </AccordionDetails>
            </Accordion>

        </div>
    );
}

export default NurseAddress;